"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _core = require("@material-ui/core");
var _helpers = require("react-platform-components/dist/helpers");
var _config = require("../../../config");
var _noImage = _interopRequireDefault(require("../../../assets/no-image.jpg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Image = function Image(_ref) {
  var children = _ref.children,
    product = _ref.product;
  var image = null;
  if (!_lodash.default.isEmpty(product === null || product === void 0 ? void 0 : product.main_image)) {
    if (_config.PRODUCTS_LIST_FIELDS.includes("main_image")) {
      image = product.main_image.name["500x500"];
    }
  } else {
    if (!_lodash.default.isEmpty(product === null || product === void 0 ? void 0 : product.images)) {
      image = product.images[0].name["500x500"];
    }
  }
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    position: "relative",
    overflow: "hidden",
    paddingTop: "100%",
    borderRadius: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "object-cover",
    src: image ? (0, _helpers.joinPaths)(_config.BASE_URL, image) : _noImage.default,
    alt: product.name,
    width: "100%",
    height: "100%"
  })), children);
};
exports.Image = Image;